import Spinner from 'react-bootstrap/Spinner'
import { useTranslation } from "react-i18next";

function Loader({ isError }) {
    const { t } = useTranslation('messages');

    const variant = isError ? 'danger' : undefined;
    const label = isError ? t('loading.spinner.error') : t('loading.spinner.loading');

    return (
        <div className="d-flex flex-column align-items-center gap-2">
            <Spinner animation="border" role="status" variant={variant} />
            <span className="small text-muted">{label}</span>
        </div>
    );
}

export default Loader;